import classNames from 'classnames'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {RiSubtractLine} from 'react-icons/ri'

const Heading = ({ style, title, subTitle, className, icon }) => {
  const t = useTranslate()
  return (
    <div
      style={style}
      className={classNames('flex items-center gap-1 relative', className)}>
      {icon && (
        <span className="flex items-center gap-3">
          {icon}
          <RiSubtractLine size={12} />
        </span>
      )}
      <span className="flex-1 truncate">
        {_.isString(title)
          ? t(title)
          : _.isFunction(title)
          ? title()
          : title ?? null}
      </span>
      {subTitle && (
        <span className="capitalize text-2xs text-color-500 italic">
          {`( ${t(subTitle)} )`}
        </span>
      )}
    </div>
  )
}

export const CodiSubHeader = ({
  style,
  title,
  subTitle,
  className,
  bordered = true,
}) => (
  <Heading
    style={style}
    title={title}
    subTitle={subTitle}
    className={classNames(
      'uppercase text-color-300 font-medium text-sm',
      bordered && 'border-b',
      className
    )}
  />
)

export const CodiSiderHeading = ({ style, title, icon, className }) => (
  <Heading
    style={style}
    title={title}
    icon={icon}
    className={classNames(
      'border-b-2 border-primary background font-bold text-lg text-primary tracking-wider uppercase mt-3 mb-3',
      className
    )}
  />
)
